import { useEffect, useState } from 'react';
import { Checkbox, RetiredCheckboxRow, SelectContainer, SelectLabel } from './styled';
import Icon, { IconNames } from 'components/Icon';
import theme from 'config/theme';
import { TextField } from 'components/FinalForm/TextField';
import { useField } from 'react-final-form';
import { CountrySelectField, StateSelectField } from 'components/FinalForm/AddressSelectFields';
import { USER_FIELD_MAX_LENGTHS } from 'constants/userFieldMaxLengths';
import { EMPLOYMENT_FIELD_NAMES, RETIRED_OR_UNEMPLOYED } from 'helpers/utils';

export const EmploymentDetails = ({ change }) => {
  const [isChecked, setIsChecked] = useState(false);
  const {
    input: { value: country },
  } = useField('employer_country', { subscription: { value: true } });

  useEffect(() => {
    if (isChecked) {
      EMPLOYMENT_FIELD_NAMES.forEach(fieldName => {
        change(fieldName, null);
      });
      change('employer', RETIRED_OR_UNEMPLOYED);
      change('occupation', RETIRED_OR_UNEMPLOYED);
    }
  }, [isChecked]);

  const onCheckboxClick = () => {
    setIsChecked(isChecked => !isChecked);
  };

  return (
    <>
      <TextField name="employer" label="Employer" maxLength={USER_FIELD_MAX_LENGTHS.employer} />
      <TextField
        name="occupation"
        label="Occupation"
        maxLength={USER_FIELD_MAX_LENGTHS.occupation}
      />
      <label style={{ display: 'contents' }}>
        <RetiredCheckboxRow>
          <input
            type="checkbox"
            className="visually-hidden-checkbox"
            checked={isChecked}
            onChange={onCheckboxClick}
          />
          <Checkbox
            aria-hidden="true"
            $isChecked={isChecked}
            $justifyContent="space-around"
            $alignItems="center"
          >
            {isChecked && (
              <Icon
                name={IconNames.Checkmark}
                color={theme.colors.white}
                size={10}
                aria-hidden="true"
              />
            )}
          </Checkbox>
          <div>I'm retired or currently unemployed</div>
        </RetiredCheckboxRow>
      </label>
      <div></div>
      {!isChecked && (
        <>
          <TextField
            name="employer_address1"
            label="Employer Address 1"
            maxLength={USER_FIELD_MAX_LENGTHS.employer_address1}
          />
          <TextField
            name="employer_address2"
            label="Employer Address 2"
            maxLength={USER_FIELD_MAX_LENGTHS.employer_address2}
          />
          <TextField
            name="employer_city"
            label="Employer City"
            maxLength={USER_FIELD_MAX_LENGTHS.employer_city}
          />
          <SelectContainer>
            <SelectLabel>Employer State</SelectLabel>
            <StateSelectField
              country={country}
              name="employer_state"
              maxLength={USER_FIELD_MAX_LENGTHS.employer_state}
            />
          </SelectContainer>
          <TextField
            name="employer_zipcode"
            label="Employer Zip"
            maxLength={USER_FIELD_MAX_LENGTHS.employer_zipcode}
          />
          <SelectContainer>
            <SelectLabel>Employer Country</SelectLabel>
            <CountrySelectField
              name="employer_country"
              maxLength={USER_FIELD_MAX_LENGTHS.employer_country}
            />
          </SelectContainer>
        </>
      )}
    </>
  );
};
